import { makeHook } from "../../utils/makeSingleArgHook";
import getClientMarketplaceOfferings, { clientMarketplaceOfferingsUrl, } from "../requests/getClientMarketplaceOfferings";
/**
 * @deprecated new version available - please refer to useClientMarketplaceOfferingsQuery hook
 */
export function clientMarketplaceOfferingsKeyMaker(queryParams) {
    if (queryParams === null) {
        return [clientMarketplaceOfferingsUrl()];
    }
    return [clientMarketplaceOfferingsUrl(), JSON.stringify(queryParams)];
}
const useClientMarketplaceOfferings = makeHook(async (queryParams, auth) => getClientMarketplaceOfferings(auth, queryParams), (queryParams) => clientMarketplaceOfferingsKeyMaker(queryParams));
export default useClientMarketplaceOfferings;
//# sourceMappingURL=useClientMarketplaceOfferings.js.map